<template>
  <chart-container :titleChart="title" @onCSVDownload="downloadCSVGraphs()" @zoomEnabled="zoomGraph(true)" @zoomDisabled="zoomGraph(false)" :downloadId="containerId" :specificSiteId="specificSiteId" :zoomGraphValue="zoomGraphValue" :downloadShow="vis ? (vis.dataSourceTotal.dataset[0].data.length || 0 > 0 ? true : false) : false">
    <span slot="body">
      <div class=".thread-consent-ct1 recruitment-bar-container" id="bar-chart" v-if="vis ? vis.dataSourceTotal.dataset[0].data.length || 0 > 0 : false" :class="{ 'hide-study-roles-titles': specificSiteId.length > 0 }">
        <bar-chart :vis="vis" :height="height" />
      </div>
      <div v-else class=".thread-consent-ct1 recruitment-bar-container align-center">
        <div class="card-text-title no-data" v-if="dataLoaded">No Data In</div>
      </div>
    </span>
  </chart-container>
</template>
<script>
import RecruitmentFusionBarChart from "../charts/fusion/bar-chart";
import { downloadCSV } from "../../services/visualization/data-management";
import ChartContainer from "@/components/containers/chart-container";
import map from "lodash/map";

export default {
  props: {
    studyId: { type: String, default: "" },
    vis: { type: Object, default: null },
    title: {
      type: String,
      default: "Default Fusion Bar Card Title"
    },
    zoomGraphValue: { type: String, default: "" },
    containerId: { type: String },
    specificSiteId: { type: Array, default: () => [] },
    dataLoaded: { type: Boolean, default: false },
    checkedSitesApply: { type: Array, default: () => [] },
    checkedCountriesApply: { type: Array, default: () => [] }
  },
  data() {
    return {
      data: null,
      fusionBarData: null,
      zoomGraphValueChild: "",
      height: "250",
      screenFailureRawData: null,
      failureAggregation: null
    };
  },
  watch: {
    zoomGraphValue: function(newVal) {
      this.zoomGraphValueChild = newVal;
      if (newVal == "") {
        this.height = "250";
      }
    }
  },
  components: {
    ChartContainer,
    "bar-chart": RecruitmentFusionBarChart
  },
  methods: {
    async getVisScreenFailureRawData() {
      this.isLoading = true;

      let response = null;
      const params = {
        studyId: this.studyId
      };
      const responseData = await this.$api.getScreenFailureAggregationVisData(params);
      if (responseData.ok) {
        const { data } = responseData.body;
        // TODO: Dont forget to activated after api has been deployed!
        if (data !== {}) {
          response = data;
        } else {
          this.isLoading = false;
        }
      }

      this.isLoading = false;
      return response;
    },
    downloadCSVGraphs() {
      const dataTotal = this.vis.dataSourceTotal;
      let header = [];
      const newArr = [];

      header = ["Reason Name", "Number of Participants"];

      const orderArr = map(dataTotal.dataset[0].data, "value");
      orderArr.map((row, i) => {
        newArr.push([dataTotal.categories[0].category[i].label, row]);
      });

      downloadCSV(this.title, header, newArr, this.specificSiteId);
    },
    zoomGraph(status) {
      if (status) {
        this.zoomGraphValueChild = true;
        this.height = "400";
        this.$emit("zoomEnabled");
      } else {
        this.zoomGraphValueChild = false;
        this.height = "250";
        this.$emit("zoomDisabled");
      }
    },
    tabChange(tabName) {
      this.choosenTab = tabName;
    }
  }
};
</script>

<style>
.download-dropdown-item {
  line-height: 27px;
  font-size: 14px;
  padding: 0.125rem 0.75rem;
}

.download-dropdown-box {
  min-width: 6rem !important;
}

.apexcharts-tooltip {
  z-index: 100 !important;
}

.apexcharts-zoomin-icon {
  order: 3 !important;
  margin-left: 0 !important;
}

.apexcharts-zoomout-icon {
  order: 2 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.apexcharts-pan-icon {
  left: -20px !important;
  order: 1 !important;
}
</style>
